import { render, staticRenderFns } from "./SidebarAboutBuffer.vue?vue&type=template&id=b8bd0ebe"
import script from "./SidebarAboutBuffer.vue?vue&type=script&lang=js"
export * from "./SidebarAboutBuffer.vue?vue&type=script&lang=js"
import style0 from "./SidebarAboutBuffer.vue?vue&type=style&index=0&id=b8bd0ebe&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports